export class CodingVersion {
    element: string;
    value: string;
}